import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=4949f852&scoped=true"
import script from "./TransactionTable.vue?vue&type=script&lang=js"
export * from "./TransactionTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&id=4949f852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949f852",
  null
  
)

export default component.exports